var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiddenDanger"},[_c('div',{staticClass:"pig"},[_c('div',[_vm._v("隐患状态统计")]),_vm._v(" "),_c('div',{style:({width: '100%', height: '320px'}),attrs:{"id":"dangerChat"}})]),_vm._v(" "),_c('div',{staticClass:"danger_footer"},[_c('div',{style:({width: '100%', height: '400px'}),attrs:{"id":"dangerChat2"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c9892a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hiddenDanger.vue
// module id = null
// module chunks = 